module.exports = __webpack_public_path__ + "static/img/gx1.f4c9a48.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/gx1.png
// module id = tNP9
// module chunks = 1